import TransactionDetail from './TransactionDetail';

export default TransactionDetail;